import { FC, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Field, Form } from "react-final-form";
import { ChevronRightIcon, DeleteIcon, InfoIcon } from "@chakra-ui/icons";
import {
  useGetGallery,
  useGetVehicle,
  useSetGallery,
  useVehicleList,
} from "../../hooks";
import {
  Box,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Divider,
  Heading,
  SimpleGrid,
  useToast,
  VStack,
  Image,
  Center,
  Text,
  CircularProgress,
  Container,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  IconButton,
} from "@chakra-ui/react";
import {
  CustomInput,
  CustomCheckbox,
  CustomSelect,
  DownloadFile,
} from "../../../customComponents/components";
import { useVehicleMarkList } from "../../../vehicleMark/hooks";
import { useVehicleTypeList } from "../../../vehicleType/hooks";
import { useVehicleMarkList as useVehicleColorList } from "./../../../color/hooks";
import { handlePicDownload, selectPlace, validate } from "../../helpers";
import { useParams } from "react-router";
import { destructure, handleLink, isDisabled } from "../../../editUser/helpers";
import {
  // IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  ListSubheader,
} from "@mui/material";
import {
  DonwloadComponent,
  DonwloadComponentNew,
} from "../../../customComponents/components/CustomInput/CustomInput";
import { PageHead } from "../../../home/components/PageHead";
import { HeadButton } from "../../../customComponents/components/HeadButton";
import { CardsBlock } from "../../../editUser/components/CardsBlock";
import { VehicleTariffScreen } from "../../../vehicleTariff/screens";
import { useRedirect, useUserList } from "../../../home/hooks";
import { useGetFavorite } from "../../../editUser/hooks";
import { FuncButton } from "../../../customComponents/components/FuncButton";

const fields = {
  first_row: [
    {
      key: 1,
      name: "title",
      placeholder: "Название",
      label: "Название",
      type: "type",
    },
    {
      key: 2,
      name: "vehicle_type_id",
      placeholder: "Тип автомобиля",
      label: "Тип автомобиля",
      type: "select",
    },
    {
      key: 3,
      name: "vehicle_mark_id",
      placeholder: "Марка автомобиля",
      label: "Марка автомобиля",
      type: "select",
    },
  ],
  second_row: [
    {
      key: 30,
      name: "color_id",
      placeholder: "Цвет",
      label: "Цвет",
      type: "select",
    },
    {
      key: 4,
      name: "power",
      placeholder: "105",
      label: "Мощность (л.с.)",
      type: "number",
    },
    {
      key: 5,
      name: "volume",
      placeholder: "2.0",
      label: "Объем двигателя (л.)",
      type: "text",
    },
  ],
  third_row: [
    {
      key: 6,
      name: "racing",
      placeholder: "2",
      label: "Разгон (c)",
      type: "text",
    },
    {
      key: 7,
      name: "engine_layout",
      placeholder: "Продольное",
      label: "Расположение двигателя / привод",
      type: "text",
    },
    {
      key: 8,
      name: "sits_number",
      placeholder: "Количество мест",
      label: "Количество мест",
      type: "select",
    },
  ],
  fourth_row: [
    {
      key: 9,
      name: "insurance_deposit",
      placeholder: "Страховой депозит",
      label: "Страховой депозит",
      type: "number",
    },
    {
      key: 10,
      name: "text_label",
      placeholder: "Текстовый лейбл (например Новый автомобиль)",
      label: "Текстовый лейбл (например Новый автомобиль)",
      type: "text",
    },
  ],
  media: [
    {
      key: 11,
      name: "main_image",
      label: "Главное изображение",
      type: "file",
    },
    {
      key: 12,
      name: "video",
      label: "Ссылка на видео YouTube",
      type: "text",
    },
  ],
  gallery: [
    {
      key: 13,
      name: "gallery",
      label: "Галерея",
      type: "file",
    },
  ],
};

export const EditVehicle: FC = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const { setVehicle } = useVehicleList();
  const { vehicleMarkList } = useVehicleMarkList();
  const { vehicleTypeList } = useVehicleTypeList();
  const { vehicleColorList } = useVehicleColorList();
  // const { vehiclesList } = useVehicleList();
  const { favoriteList, favoriteLoading } = useGetFavorite();
  const { userList } = useUserList();
  const { redirectToEdit } = useRedirect();

  const userAddedFav = useMemo(() => {
    if (userList.length && favoriteList.length) {
      return userList.filter((u) => {
        if (
          favoriteList?.find(
            (f) => f.vehicle_id == id.toString() && f.user_id == u.id,
          )
        ) {
          return true;
        }
        return false;
      });
    }
    return [];
  }, [userList, favoriteList, id]);

  const { galleryData, getGallery } = useGetGallery(id);
  const { vehicleData } = useGetVehicle(id);
  const {
    engine_layout,
    insurance_deposit,
    text_label,
    main_image,
    power,
    racing,
    sits_number,
    title,
    vehicle_mark_id,
    vehicle_type_id,
    video,
    volume,
    color_id,
  } = vehicleData;
  const { setGallery, deleteImage } = useSetGallery();

  const toast = useToast();
  const navigate = useNavigate();

  const onSubmit = (values) => {
    // return;
    setLoading(true);
    setVehicle(values).then(({ data }) => {
      const vehicle_id = data.data.id;
      // console.log(
      //   'values["gallery"]?',
      //   values["gallery"],
      //   values["gallery"] instanceof FileList,
      // );
      //@ts-ignore
      if (values["gallery"]?.every((f) => f instanceof File)) {
        setGallery({ vehicle_id, image: values.gallery }).then(() => {
          setLoading(false);
          toast({
            title: "Успешно",
            description: "Данные сохранены",
            status: "success",
            duration: 4000,
            isClosable: true,
          });
          navigate("/vehicles");
        });
      } else {
        setLoading(false);
        toast({
          title: "Успешно",
          description: "Данные сохранены",
          status: "success",
          duration: 4000,
          isClosable: true,
        });
        navigate("/vehicles");
      }
    });
  };

  const deleteImageGallery = async (id) => {
    await deleteImage(id);
    await getGallery();
  };

  const API_URL = process.env.REACT_APP_API_URL;

  const handleRedirectTariff = () => {
    navigate(`/vehicle_tariff/${id}`);
  };

  if (loading) {
    return (
      <Box boxShadow="lg" p="6" rounded="md" bg="white">
        <Center>
          <CircularProgress isIndeterminate />
        </Center>
      </Box>
    );
  }

  console.log("userAddedFav", userAddedFav);

  return (
    <>
      <Box bg="#F7F7F7" borderBottom={"1px solid #A6A8AE"}>
        <Container maxWidth="1160px">
          <Flex justify="space-between" alignItems={"center"} h="110px">
            <Breadcrumb
              spacing="8px"
              separator={<ChevronRightIcon color="gray.500" />}
            >
              <BreadcrumbItem>
                <BreadcrumbLink as={Link} to="/vehicles">
                  Автомобили
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem isCurrentPage>
                <BreadcrumbLink href="#">
                  Редактирование автомобиля
                </BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
            {/* <Flex alignItems="center" gap="8px">
              <Button>В избранном у 5 людей</Button>
              <HeadButton onClick={handleRedirectTariff}>
                Редактировать цены
              </HeadButton>
            </Flex> */}
          </Flex>
        </Container>
      </Box>
      <Divider marginTop={"20px"} marginBottom={"20px"} />
      <Container maxWidth="1160px" padding="0">
        <Tabs isFitted>
          <TabList>
            <Tab _selected={{ color: "#FFFFFF", bg: "#282C35" }}>
              Основная информация
            </Tab>
            <Tab _selected={{ color: "#FFFFFF", bg: "#282C35" }}>Цены</Tab>
            <Tab _selected={{ color: "#FFFFFF", bg: "#282C35" }}>
              Добавили в избранное ({userAddedFav.length})
            </Tab>
          </TabList>
          <TabPanels borderTop="1px solid #282C35" paddingTop="43px">
            <TabPanel padding="0">
              <Form
                mutators={{
                  setValue: ([field, value], state, { changeValue }) => {
                    changeValue(state, field, () => value);
                  },
                }}
                onSubmit={onSubmit}
                validate={validate}
                initialValues={{
                  id,
                  engine_layout,
                  insurance_deposit,
                  text_label: text_label == "null" ? "" : text_label,
                  main_image,
                  power,
                  racing,
                  sits_number,
                  title,
                  vehicle_mark_id,
                  vehicle_type_id,
                  color_id,
                  video,
                  volume,
                  gallery: galleryData,
                }}
                render={({ form, handleSubmit, values }) => {
                  //@ts-ignore
                  window.form = form;
                  return (
                    <>
                      <CardsBlock title="Основная информация" user_id={""}>
                        <SimpleGrid
                          minChildWidth="120px"
                          spacing="40px"
                          marginTop={"20px"}
                          marginBottom={"20px"}
                        >
                          {fields.first_row.map(
                            ({ key, name, placeholder, label, type }) =>
                              type === "select" ? (
                                <Field
                                  key={key}
                                  name={name}
                                  component={CustomSelect}
                                  options={(() => {
                                    if (name === "vehicle_mark_id") {
                                      return vehicleMarkList;
                                    }
                                    if (name === "vehicle_type_id") {
                                      return vehicleTypeList;
                                    }
                                    if (name === "color_id") {
                                      return vehicleColorList;
                                    }
                                    return [];
                                  })()}
                                  placeholder={placeholder}
                                  label={label}
                                />
                              ) : (
                                <Field
                                  key={key}
                                  name={name}
                                  placeholder={placeholder}
                                  label={label}
                                  component={CustomInput}
                                  type={type}
                                />
                              ),
                          )}
                        </SimpleGrid>
                        <Divider marginTop={"20px"} marginBottom={"20px"} />
                        <SimpleGrid
                          minChildWidth="120px"
                          spacing="40px"
                          marginTop={"20px"}
                          marginBottom={"20px"}
                        >
                          {fields.second_row.map(
                            ({ key, name, placeholder, label, type }) =>
                              type === "select" ? (
                                <Field
                                  key={key}
                                  name={name}
                                  component={CustomSelect}
                                  options={(() => {
                                    if (name === "vehicle_mark_id") {
                                      return vehicleMarkList;
                                    }
                                    if (name === "vehicle_type_id") {
                                      return vehicleTypeList;
                                    }
                                    if (name === "color_id") {
                                      return vehicleColorList;
                                    }
                                    return [];
                                  })()}
                                  placeholder={placeholder}
                                  label={label}
                                />
                              ) : (
                                <Field
                                  key={key}
                                  name={name}
                                  placeholder={placeholder}
                                  label={label}
                                  component={CustomInput}
                                  type={type}
                                />
                              ),
                          )}
                        </SimpleGrid>
                        <Divider marginTop={"20px"} marginBottom={"20px"} />
                        <SimpleGrid
                          minChildWidth="120px"
                          spacing="40px"
                          marginTop={"20px"}
                          marginBottom={"20px"}
                        >
                          {fields.third_row.map(
                            ({ key, name, placeholder, label, type }) =>
                              type === "checkbox" ? (
                                <Field
                                  key={key}
                                  name={name}
                                  placeholder={placeholder}
                                  label={label}
                                  component={CustomCheckbox}
                                  type={type}
                                />
                              ) : (
                                <Field
                                  key={key}
                                  name={name}
                                  placeholder={placeholder}
                                  label={label}
                                  component={CustomInput}
                                  type={type}
                                />
                              ),
                          )}
                        </SimpleGrid>
                        <Divider marginTop={"20px"} marginBottom={"20px"} />
                        <SimpleGrid
                          minChildWidth="120px"
                          spacing="40px"
                          marginTop={"20px"}
                          marginBottom={"20px"}
                        >
                          {fields.fourth_row.map(
                            ({ key, name, placeholder, label, type }) =>
                              type === "checkbox" ? (
                                <Field
                                  key={key}
                                  name={name}
                                  placeholder={placeholder}
                                  label={label}
                                  component={CustomCheckbox}
                                  type={type}
                                />
                              ) : (
                                <Field
                                  key={key}
                                  name={name}
                                  placeholder={placeholder}
                                  label={label}
                                  component={CustomInput}
                                  type={type}
                                />
                              ),
                          )}
                        </SimpleGrid>
                      </CardsBlock>
                      <Divider marginTop={"20px"} marginBottom={"20px"} />
                      <CardsBlock title="Главное изображение" user_id={""}>
                        <DonwloadComponentNew
                          name={"main_image"}
                          intialPreview={values["main_image"]}
                          label={"Главное изображение"}
                          multiple={false}
                          fullwidth={false}
                        />
                      </CardsBlock>
                      <Divider marginTop={"20px"} marginBottom={"20px"} />
                      <CardsBlock
                        title="Видео (ссылка на YouTube)"
                        user_id={""}
                      >
                        <Field
                          name="video"
                          placeholder="Видео (ссылка на YouTube)"
                          label={"Видео (ссылка на YouTube)"}
                          component={CustomInput}
                          type={"text"}
                        />
                      </CardsBlock>
                      <Divider marginTop={"20px"} marginBottom={"20px"} />
                      <CardsBlock title="Галерея" user_id={""}>
                        {fields.gallery.map(({ key, name, label, type }) => (
                          <VStack spacing={4} align="flex-start" key={key}>
                            <DonwloadComponentNew
                              name={"gallery"}
                              label={label}
                              multiple
                              fullwidth
                              intialPreview={""}
                            />
                            {galleryData.length && (
                              <Text marginBottom={"20px"}>
                                Загруженные фотографии:{" "}
                              </Text>
                            )}
                            {galleryData.length ? (
                              <ImageList
                                cols={3}
                                sx={{
                                  width: "100%",
                                  height: 550,
                                  margin: "20px",
                                  marginLeft: "-20px",
                                  marginRight: "-20px",
                                }}
                              >
                                {galleryData.length &&
                                  galleryData.map(
                                    ({ id, image, other, vehicle_id }) => (
                                      <ImageListItem key={id}>
                                        <Image
                                          src={`${API_URL}/${image}`}
                                          maxW={"100%"}
                                          position="relative"
                                        />
                                        <Flex
                                          flexDirection="row"
                                          alignItems={"center"}
                                          justifyContent="space-around"
                                          width="100%"
                                          sx={{
                                            position: "absolute",
                                            bottom: "20px",
                                            left: "0",
                                          }}
                                        >
                                          <Button
                                            onClick={() => {
                                              handlePicDownload(image);
                                            }}
                                            disabled={!values[name]}
                                            sx={{
                                              width: "67px",
                                              height: "26px",
                                              background: "#fff",
                                              borderRadius: "5px",
                                              fontWeight: "700",
                                              fontSize: "10px",
                                              lineHeight: "12px",
                                              color: "#55769D",
                                            }}
                                          >
                                            Скачать
                                          </Button>
                                          <IconButton
                                            aria-label="Delete pics"
                                            onClick={() => {
                                              deleteImageGallery(id);
                                            }}
                                            icon={<DeleteIcon />}
                                            width="26px"
                                            height="26px"
                                          />
                                        </Flex>
                                        {/* <Flex
                                          flexDirection="row"
                                          alignItems={"center"}
                                          justifyContent="space-around"
                                          width="100%"
                                          paddingRight={"20px"}
                                          paddingLeft={"20px"}
                                          sx={{
                                            position: "absolute",
                                            bottom: "20px",
                                            left: "0",
                                          }}
                                        >
                                          <Button
                                            onClick={() => {
                                              handlePicDownload(image);
                                            }}
                                            disabled={!values[name]}
                                          >
                                            Скачать документ
                                          </Button>
                                          <Button
                                            onClick={() => {
                                              deleteImageGallery(id);
                                            }}
                                          >
                                            Удалить документ
                                          </Button>
                                        </Flex> */}
                                      </ImageListItem>
                                    ),
                                  )}
                              </ImageList>
                            ) : (
                              <Text>Изображения отсутствуют</Text>
                            )}
                          </VStack>
                        ))}
                      </CardsBlock>
                      <Divider marginTop={"20px"} marginBottom={"20px"} />

                      <Button onClick={handleSubmit}>Сохранить</Button>
                    </>
                  );
                }}
              />
            </TabPanel>
            <TabPanel padding="0">
              <VehicleTariffScreen vehicle_id={id} />
            </TabPanel>
            <TabPanel padding="0">
              <Table variant="simple">
                <Thead>
                  <Tr>
                    <Th>ID</Th>
                    <Th>Имя</Th>
                    <Th>Телефон</Th>
                    <Th>СБ</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {userAddedFav.map(
                    ({
                      id,
                      phone,
                      username,
                      confirmed,
                      security_check,
                      disabled,
                    }) => (
                      <Tr key={id}>
                        <Td>
                          <Text fontSize="sm" color="#121419">
                            {id}
                          </Text>
                        </Td>
                        <Td>
                          <Text fontSize="sm" color="#121419">
                            {username}
                          </Text>
                        </Td>
                        <Td>
                          <Text fontSize="sm" color="#121419">
                            {phone}
                          </Text>
                        </Td>
                        <Td>
                          <Text
                            fontSize="sm"
                            fontWeight={"700"}
                            color={
                              disabled === "1"
                                ? "#D77E59"
                                : security_check > 0
                                  ? "#56AB6E"
                                  : "#7D8DB5"
                            }
                          >
                            {(() => {
                              console.log(
                                "id, security_check",
                                id,
                                security_check,
                              );
                              if (security_check == "pending") {
                                return "Ожидает";
                              }
                              if (security_check == "1") {
                                return "Пройдена";
                              }
                              if (security_check == "blocked") {
                                return "Заблокирован";
                              }
                              return "Ожидает";
                            })()}
                          </Text>
                        </Td>
                        <Td isNumeric>
                          <FuncButton
                            onClick={() => redirectToEdit(id)}
                            disabled={username === "admin"}
                          >
                            Редактировать
                          </FuncButton>
                        </Td>
                      </Tr>
                    ),
                  )}
                </Tbody>
              </Table>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Container>
    </>
  );
};
